import Vue from "vue";
import Vuetify from "vuetify/lib";
//import sv from "i18n/vuetify/sv";
// import sv from 'vuetify/es5/locale/sv'
import VueI18n from "vue-i18n";
// import sv from "vuetify";

Vue.use(Vuetify);
Vue.use(VueI18n);

// Vue.use(Vuetify, {
//     lang: {
//       locales: { sv },
//       current: 'sv'
//     }
//   })

  Vue.component('VDataTable', {
    methods: {
      changeLocale () {
        this.$vuetify.lang.current = 'sv'
      }
    }
  })

  const messages = {
    en: {
      $vuetify: {
        VDataTable: {
          itemsPerPageText: 'Items per page:',
          pageText: '{0}-{1} of {2}',
        },
      },
    },
    sv: {
      $vuetify: {
        VDataTable: {
          itemsPerPageText: 'Element per sida:',
          pageText: '{0}-{1} av {2}',
        },
      },
    },
  }

  const i18n = new VueI18n({
    locale: 'sv', // set locale
    messages, // set locale messages
  })

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: "#FFA500",
                secondary: "#000000"
            }
        },
        lang: {
          t: (key, ...params) => i18n.t(key, params),
        },
        dataTable: {
          itemsPerPageText: "items per page"
        }
    }
});
